exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".style-cssmodule-inputGrid-3o39T{display:flex;flex-direction:column;row-gap:25px}.style-cssmodule-forgottenPassword-1rhwq{color:var(--color-night-gray8,#32435e);font-family:Roboto;font-size:14px;font-style:normal;font-weight:400;line-height:22px;letter-spacing:.14px;margin-top:24px;margin-left:auto;width:fit-content;display:block}.style-cssmodule-resetLink-2x921{text-decoration-line:underline;text-decoration-style:solid;text-decoration-skip-ink:auto;text-decoration-thickness:auto;text-underline-offset:auto;text-underline-position:from-font;cursor:pointer}.style-cssmodule-signInButton-3Leec{font-weight:700;display:flex;align-items:center;justify-content:center;column-gap:12px;fill:var(--color-white,#fff)}.style-cssmodule-title-3LqDM{color:var(--color-blue-middle,#1147b7);font-family:Roboto;font-size:40px;font-style:normal;font-weight:500;line-height:40px;letter-spacing:.4px}.style-cssmodule-subtitle-1uLoy{color:var(--color-sky-gray6,#8793a6);font-family:Roboto;font-size:18px;font-style:italic;font-weight:400;line-height:22px}.style-cssmodule-messageTopRight-2XJ6z{position:fixed;top:30px;right:20px;max-width:90vw}", ""]);

// exports
exports.locals = {
	"inputGrid": "style-cssmodule-inputGrid-3o39T",
	"forgottenPassword": "style-cssmodule-forgottenPassword-1rhwq",
	"resetLink": "style-cssmodule-resetLink-2x921",
	"signInButton": "style-cssmodule-signInButton-3Leec",
	"title": "style-cssmodule-title-3LqDM",
	"subtitle": "style-cssmodule-subtitle-1uLoy",
	"messageTopRight": "style-cssmodule-messageTopRight-2XJ6z"
};


//////////////////
// WEBPACK FOOTER
// ../~/css-loader?{"modules":true,"importLoaders":1,"localIdentName":"[name]-[local]-[hash:base64:5]"}!./routes/login/components/cpm_client/components/SignIn/style.cssmodule.css
// module id = 2569
// module chunks = 121